<template>
  <div class="__AnnouncementsList">
    <template v-if="data.length === 0">
      <span class="__AnnouncementsList-NoItem">{{ $t('There is no information.') }}</span>
    </template>

    <template v-else>
      <div
        class="__AnnouncementsList-ListItem"
        :class="{ dense: dense }"
        v-for="val in data"
        :key="val.id"
      >
        <div class="__AnnouncementsList-Date">
          <CDate :value="val.date" format="lll" />
        </div>
        <div>
          <span v-html="$sanitizer(val.message)" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Vue from 'vue';
import CTitle from '@/components/uikit/CTitle';
import CDate from '@/components/uikit/CDate';

const messages = {
  en: {
    'There is no information.': 'There are no announcements.',
  },
  ja: {
    'There is no information.': 'お知らせはありません。',
  },
};

export default Vue.extend({
  name: 'Announcements',
  i18n: { messages },
  components: { CTitle, CDate },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    dense: {
      type: Boolean,
    },
  },
});
</script>

<style lang="scss" scoped>
.__AnnouncementsList {
  &-ListItem {
    padding: $space-xs 0;

    &.dense {
      padding: $space-xxs 0;
    }
  }

  &-Date {
    font-size: $font-size-sm;
    color: $neutral-secondary-color;
    line-height: 1;
  }

  &-NoItem {
    font-size: $font-size-sm;
  }
}
</style>
